import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { type IRow, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { type Campaign } from 'entities/Campaign'
import { useCampaignsListContext } from 'pages/campaigns/ui/CampaignsList/context/context'
import { CampaignRoutes } from 'pages/campaigns/types'
import { getColumns } from './getColumns'
import styles from './styles.module.scss'

export const CampaignsTable = observer(() => {
  const {
    tableStore,
    items,
    startPaginationSize,
    limit,
    page,
    onPaginationModelChange,
    total,
    loading,
  } = useCampaignsListContext()

  const getRowLink = (row: IRow<Campaign>) =>
    `/${CampaignRoutes.root}/${CampaignRoutes.detail}/${row.id}`

  const columns = useMemo(getColumns, [])

  if (!items.length) {
    return <NoResultsFound />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'CampaignsTable'}
        pinnedColumnNames={['name']}
        store={tableStore}
        columns={columns}
        rows={items}
        getRowLink={getRowLink}
        rowsCount={total}
        isLoading={loading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        startPaginationSize={startPaginationSize}
        sxTable={{ marginRight: '10px', width: 'calc(100% - 10px)' }}
      />
    </div>
  )
})
